export default __webpack_public_path__ + "static/media/essentialWebsiteSample3.3c634d54.png";